import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { scrollToSection } from "@/lib/scroll";

const reveal = {
  hidden: { opacity: 0, y: 28 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.12, duration: 0.8, ease: [0.16, 1, 0.3, 1] },
  }),
};

export default function Manifesto() {
  return (
    <section id="vad-jag-lovar" data-testid="manifesto-section" className="border-b border-white/10 py-20 sm:py-32">
      <div className="mx-auto grid max-w-7xl gap-14 px-4 sm:px-6 lg:grid-cols-12 lg:gap-10 lg:px-8">
        <div className="lg:col-span-7">
          <motion.p
            variants={reveal}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-80px" }}
            className="font-mono text-xs uppercase tracking-[0.22em] text-neutral-500"
          >
            01 / Vad vi lovar dig som kund
          </motion.p>

          <motion.blockquote
            data-testid="manifesto-quote"
            custom={1}
            variants={reveal}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-80px" }}
            className="mt-6 font-display text-4xl font-semibold uppercase leading-[1.02] tracking-tight text-white sm:text-5xl"
          >
            ”Vi gör vårt bästa, <span className="text-neutral-500">även när ingen ser på.</span>”
          </motion.blockquote>

          <motion.div
            custom={2}
            variants={reveal}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-80px" }}
            className="mt-8 max-w-2xl space-y-5 text-base leading-relaxed text-neutral-300 sm:text-lg"
          >
            <p>
              Vårt motto är att alltid göra vårt bästa, även när ingen ser på. Det kommer mycket från en syn på att
              saker ska göras så bra som möjligt från början.
            </p>
            <p>
              För oss handlar ett bra hantverk inte bara om det som syns när arbetet är färdigt. Det handlar lika
              mycket om det som finns bakom väggar, under installationer och på platser som kanske aldrig kommer att
              synas.
            </p>
            <p>
              Vi vill kunna lämna varje arbete och känna att det är gjort på ett sätt vi själva kan stå för. Det tror
              vi också är något du som kund kommer att märka när vi får möjligheten att hjälpa dig.
            </p>
          </motion.div>

          <motion.button
            type="button"
            data-testid="manifesto-cta-projects"
            custom={3}
            variants={reveal}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-80px" }}
            onClick={() => scrollToSection("#projekt")}
            className="group mt-10 flex items-center gap-2 border border-white/25 px-7 py-4 font-mono text-xs uppercase tracking-[0.18em] text-white transition-colors duration-200 hover:border-white/70"
          >
            Se våra projekt
            <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </motion.button>
        </div>

        <motion.div
          initial={{ opacity: 0, x: 32 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-5"
        >
          <div className="steel-card hairline-t border border-white/10 p-2">
            <div className="overflow-hidden">
              <img
                src="/assets/fredrik-welding.webp"
                alt="Svetsning med gnistor – Uusimaa Svets & VVS AB i Storstockholm"
                loading="lazy"
                className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-[1.03]"
              />
            </div>
            <p className="flex items-center justify-between px-3 py-3 font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">
              <span>I arbetet — Uusimaa Svets & VVS AB</span>
              <span className="text-weld">FIG. 01</span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
